import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthPlacement} from "../types/AmplitudeAuthPlacement";

export type AmplitudeUnlockChoiceModalName =
    | "post_price_reveal"
    | "download_floor_plan"
    | "price_history"
    | "developer_report"
    | "construction_photos"
    | "area_photos"
    | "faq";

export type AmplitudeReservationModalName = "reservation_code" | "reservation_confirmed";

// the steps of the reservation started from the offer choice of the unlock choice modal
export type AmplitudeUnlockChoiceReservationModalName = "rp_reservation_code" | "rp_reservation_confirmed";

export type AmplitudeModalName =
    | "phone_verify"
    | "auth_phone"
    | "auth_name"
    | "post_price_reveal_modal"
    | "rp_preferences"
    | "price_negotiate"
    | "rp_hotline_consultant"
    | "area_photos_paywall"
    | AmplitudeUnlockChoiceModalName
    | AmplitudeReservationModalName
    | AmplitudeUnlockChoiceReservationModalName;

export type AmplitudeModalLocation = "property_page" | "investment_page" | "listing_page" | "listing_map" | "homepage" | "rp_ai_chat" | null;

interface ITrackAmplitudeViewModalParams {
    modalName: AmplitudeModalName;
    location: AmplitudeModalLocation;
    phoneVerifyPlacement?: AmplitudeAuthPlacement | null;
    authPlacement?: AmplitudeAuthPlacement | null;
    itemId?: number | null;
    propertyId?: number | null;
    /** Modal-specific properties defined in the Amplitude knowledge base. */
    additionalEventProperties?: Record<string, string | number | null>;
}

export const trackAmplitudeViewModal = (params: ITrackAmplitudeViewModalParams): void => {
    trackAmplitudeEvent("view_modal", {
        modal_name: params.modalName,
        location: params.location,
        ...(params.phoneVerifyPlacement !== undefined && {phone_verify_placement: params.phoneVerifyPlacement}),
        ...(params.authPlacement !== undefined && {auth_placement: params.authPlacement}),
        ...(params.itemId !== undefined && {item_id: params.itemId}),
        ...(params.propertyId !== undefined && {property_id: params.propertyId}),
        ...params.additionalEventProperties
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthPlacement} from "../types/AmplitudeAuthPlacement";

export type AmplitudeUnlockChoiceModalName =
    | "post_price_reveal"
    | "download_floor_plan"
    | "price_history"
    | "developer_report"
    | "construction_photos"
    | "area_photos"
    | "faq";

export type AmplitudeReservationModalName = "reservation_code" | "reservation_confirmed";

// the steps of the reservation started from the offer choice of the unlock choice modal
export type AmplitudeUnlockChoiceReservationModalName = "rp_reservation_code" | "rp_reservation_confirmed";

export type AmplitudeModalName =
    | "phone_verify"
    | "auth_phone"
    | "auth_name"
    | "post_price_reveal_modal"
    | "rp_preferences"
    | "price_negotiate"
    | "rp_hotline_consultant"
    | "area_photos_paywall"
    | AmplitudeUnlockChoiceModalName
    | AmplitudeReservationModalName
    | AmplitudeUnlockChoiceReservationModalName;

export type AmplitudeModalLocation = "property_page" | "investment_page" | "listing_page" | "listing_map" | "homepage" | "rp_ai_chat" | null;

interface ITrackAmplitudeViewModalParams {
    modalName: AmplitudeModalName;
    location: AmplitudeModalLocation;
    phoneVerifyPlacement?: AmplitudeAuthPlacement | null;
    authPlacement?: AmplitudeAuthPlacement | null;
    itemId?: number | null;
    propertyId?: number | null;
    /** Modal-specific properties defined in the Amplitude knowledge base. */
    additionalEventProperties?: Record<string, string | number | null>;
}

export const trackAmplitudeViewModal = (params: ITrackAmplitudeViewModalParams): void => {
    trackAmplitudeEvent("view_modal", {
        modal_name: params.modalName,
        location: params.location,
        ...(params.phoneVerifyPlacement !== undefined && {phone_verify_placement: params.phoneVerifyPlacement}),
        ...(params.authPlacement !== undefined && {auth_placement: params.authPlacement}),
        ...(params.itemId !== undefined && {item_id: params.itemId}),
        ...(params.propertyId !== undefined && {property_id: params.propertyId}),
        ...params.additionalEventProperties
    });
};
